import React from 'react';
import { FaucetElevation } from './FaucetElevation';
import {
  kitchenFaucetProfile,
  resolveKitchenFaucetVariant,
} from '../../3d/geometry/proceduralRenderers/proceduralSpecs';

/**
 * Kitchen faucet elevation. Variants (`resolveKitchenFaucetVariant`, shared
 * with the 3D renderer): pull-down (default), single-lever, gooseneck,
 * two-handle, wall-mount — read from `obj.subtype` / `style` / `spoutStyle`.
 * The drawing itself is `FaucetElevation` over the profile the 3D renderer
 * sweeps its meshes from (`kitchenFaucetProfile`).
 */
export { resolveKitchenFaucetVariant };

export function KitchenFaucetSchematic({
  widthMeters,
  heightMeters,
  depthMeters,
  obj = {},
  strokeColor,
  strokeWidth,
  view = 'front',
}) {
  const dims = { width: widthMeters, height: heightMeters, depth: depthMeters };
  const profile = kitchenFaucetProfile(dims, resolveKitchenFaucetVariant(obj));
  return (
    <FaucetElevation
      profile={profile}
      view={view}
      widthMeters={widthMeters}
      heightMeters={heightMeters}
      depthMeters={depthMeters}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    />
  );
}

KitchenFaucetSchematic.supportsSideViews = true;
// A faucet stands above the counter and reads the same from behind.
KitchenFaucetSchematic.supportsBackView = true;
